import React, { Component } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import MainStore from '../../../MainStore'
import AuthStore from '../../Auth/AuthStore'
import './projects.css'

export default class ProjectStatistic extends Component {
    constructor() {
        super();
        this.state = {
            totalApprovedHours: 0
        };

        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Project/GetStatistic?id=' + this.props.projectId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
            }
            else {
                res.json().then((result) => {
                    scope.setState(result);
                    MainStore.setMaskUnvisible();
                }).catch((err) => console.log(err));
            }
        });
    }

    componentDidUpdate(props) {
        if (props.projectId !== this.props.projectId) {
            this.load();
        }
    }

    render() {
        if (!this.props) {
            return <div></div>
        }
        var sumByPeople = 0;
        if (this.state.people) {
            sumByPeople = this.state.people.reduce(((accumulator, w) => accumulator + w.minutes), 0);
        }
        return (
            <div>
                <div>Всего часов: {(this.state.totalHours / 60).toFixed(2)}</div>
                <div>Всего закрыто часов: {(this.state.totalClosedHours / 60).toFixed(2)}</div>
                <div>Всего согласовано часов: {(this.state.totalApprovedHours).toFixed(2)}</div>
                <div>Всего задач: {this.state.tasksCount}</div>
                <div>Закрыто задач: {this.state.closedTasksCount}</div>
                <div>Стоимость часа: {this.state.hourCost? this.state.hourCost.toFixed(2) : 0}руб</div>
                <br/>
                <div>План проекта {this.state.planHours}ч. Всего учтено {this.state.totalPlanHours}ч. Из них закрыто {this.state.closedPlanHours}ч.</div>
                <LinearProgress variant="buffer" value={100*this.state.closedPlanHours / this.state.planHours} valueBuffer={100*this.state.totalPlanHours / this.state.planHours} />
                <br/>
                <div>
                    {this.state.people && this.state.people.sort((a, b) => b.minutes - a.minutes).map(p =>
                        <div>
                            {p.user} 
                                <LinearProgress variant="determinate" value={100 * (p.minutes) / (sumByPeople)} />
                            {(p.minutes / 60).toFixed(2)}ч
                              
                            </div>)}
                </div>
            </div>
        );
    }
}
